angular.module('impactx.company').controller('CompanyLogoCtrl', [
    '$scope',
    'dataGen',
    'TranslationService',
    'ToastService',
    '$mdDialog',
    'themeFactory',
    'comId',
    CompanyLogoCtrl
]);

function CompanyLogoCtrl($scope, dataGen, TranslationService, ToastService, $mdDialog, themeFactory, comId) {
    
    var self = this;
    
    $scope.saveLabel = TranslationService.get('save');
    $scope.abortLabel = TranslationService.get('abort');
    $scope.theme = themeFactory.getTheme();

    dataGen.getData($scope, {id: comId}, "/company/logo/view");

    self.cancel = function () {
        $mdDialog.cancel();
    };

    self.save = function () {
        dataGen.postAsForm($scope, {formData: $scope.data}, "/company/logo/save").then(function () {
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
            $mdDialog.cancel();
        });
    };
}